var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-wrapper"},[_c('div',{staticClass:"footer",class:{
      'is-landing': _vm.type === 'landing',
      'is-adaptive': _vm.is_adaptive,
      'public-response': _vm.public_response,
      'grid': _vm.is_grid
    }},[_c('div',[_c('a',{staticClass:"footer-copyright-img",attrs:{"target":"_blank","rel":"noopener","href":`https://${_vm.domainLink}/`}},[_c('img',{attrs:{"src":"/static/images/elements/footer-recruiter.svg"}})]),_vm._v(" "),_c('span',{staticClass:"copyright footer-group"},[_vm._v(_vm._s(_vm.$tr('copyright_landing', {
        year: this.year
      })))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }